// jQuery plugins
import './globals/jquery';
import 'jquery-trend';
import 'jquery-revealer';

// Global imports
import './globals/flickity-ios-fix';

// Template imports
import Account from './templates/Account';
import Contact from './templates/Contact';
import Page from './templates/Page';

// Section imports
import Sections from './Sections';
import StaticSectionHeader from './sections/StaticSectionHeader';
import StaticSectionFooter from './sections/StaticSectionFooter';
import StaticArticle from './sections/StaticArticle';
import StaticBlog from './sections/StaticBlog';
import StaticCart from './sections/StaticCart';
import StaticCollection from './sections/StaticCollection';
import StaticGiftcard from './sections/StaticGiftcard';
import StaticPassword from './sections/StaticPassword';
import StaticProduct from './sections/StaticProduct';
import StaticSearch from './sections/StaticSearch';
import DynamicBlogPosts from './sections/DynamicBlogPosts';
import StaticHighlightsBanners from './sections/StaticHighlightsBanners';
import StaticSlideshow from './sections/StaticSlideshow';
import DynamicPromoBlocks from './sections/DynamicPromoBlocks';
import DynamicMenuList from './sections/DynamicMenuList';
import DynamicTwitterFeed from './sections/DynamicTwitterFeed';
import DynamicInstagramFeed from './sections/DynamicInstagramFeed';
import DynamicFeaturedCollection from './sections/DynamicFeaturedCollection';
import DynamicSearch from './sections/DynamicSearch';
import DynamicVideo from './sections/DynamicVideo';

const sections = new Sections();
sections.register('static-header', section => new StaticSectionHeader(section));
sections.register('static-footer', section => new StaticSectionFooter(section));
sections.register('static-article', section => new StaticArticle(section));
sections.register('static-blog', section => new StaticBlog(section));
sections.register('static-cart', section => new StaticCart(section));
sections.register('static-collection', section => new StaticCollection(section));
sections.register('static-giftcard', section => new StaticGiftcard(section));
sections.register('static-password', section => new StaticPassword(section));
sections.register('static-product', section => new StaticProduct(section));
sections.register('static-search', section => new StaticSearch(section));
sections.register('dynamic-blog-posts', section => new DynamicBlogPosts(section));
sections.register('static-highlights-banners', section => new StaticHighlightsBanners(section));
sections.register('static-slideshow', section => new StaticSlideshow(section));
sections.register('dynamic-promo-mosaic', section => new DynamicPromoBlocks(section));
sections.register('dynamic-promo-grid', section => new DynamicPromoBlocks(section));
sections.register('dynamic-menu-list', section => new DynamicMenuList(section));
sections.register('dynamic-twitter-feed', section => new DynamicTwitterFeed(section));
sections.register('dynamic-instagram-feed', section => new DynamicInstagramFeed(section));
sections.register('dynamic-featured-collection', section => new DynamicFeaturedCollection(section));
sections.register('dynamic-search', section => new DynamicSearch(section));
sections.register('dynamic-video', section => new DynamicVideo(section));

new Account();
new Contact();
new Page();
